import React, { useEffect, useMemo } from 'react';
import { Button, Col, Container, Row, Table } from 'reactstrap';
import Butt from './Butt';
import Logo from './Logo';
import API from '../API';
import { Apify } from '../Apify';
import I18N from '../I18N';
import { A, BlessLink, R } from '../routes';
import ChangeArrow from './ChangeArrow';
import { connect } from 'react-redux';
import { TradeButton } from './Trade';
import { T, TraksConsumer } from '../traks';
import { RangedChart, LargeChartInner } from '../c/Chart';
import { classes } from '../CUtil';
import Follow from './Follow';
import LogoAndInfo from './LogoAndInfo';
import { SortMagic } from './Tables';
import { default_currency } from '../Site';
import { array2set, setCommodityName } from '../misc';
import { computePortfolioTotals, buildDisplayAssets } from '../PortfolioHelpers';
import { ordered_and_available_market_ids } from '../markets';

const G = (props) => props.children;

function ExploreMarketsButtons(props) {
	if (props.smartphone) {
		return <A href="/explore"><Button className="ad_find_buy_btn w-100 py-2 px-3"><b><T>Find &amp; Buy equities</T></b></Button></A>;
	}

	const market_buttons = {
		"DK_STOCK": <span key="dk" className="p-2"><A href="/explore-cph"><T><Button className="ad_explore_market_button mt-2"><img alt="DK" className="ad_25x25px" src="/gfx/denmark-icon-0.svg"/><span className="pl-2">Danish</span></Button></T></A></span>,
		"SE_STOCK": <span key="se" className="p-2"><A href="/explore-sto"><T><Button className="ad_explore_market_button mt-2"><img alt="SE" className="ad_25x25px" src="/gfx/sweden-icon-0.svg"/><span className="pl-2">Swedish</span></Button></T></A></span>,
		"FI_STOCK": <span key="fi" className="p-2"><A href="/explore-hel"><T><Button className="ad_explore_market_button mt-2"><img alt="FI" className="ad_25x25px" src="/gfx/finland-icon-0.svg"/><span className="pl-2">Finnish</span></Button></T></A></span>,
		"IS_STOCK": <span key="is" className="p-2"><A href="/explore-ice"><T><Button className="ad_explore_market_button mt-2"><img alt="IS" className="ad_25x25px" src="/gfx/iceland-icon-0.svg"/><span className="pl-2">Icelandic</span></Button></T></A></span>,
		"DE_STOCK": <span key="de" className="p-2"><A href="/explore-xetra"><T><Button className="ad_explore_market_button mt-2"><img alt="DE" className="ad_25x25px" src="/gfx/germany-icon-0.svg"/><span className="pl-2">German</span></Button></T></A></span>,
		"AT_STOCK": <span key="at" className="p-2"><A href="/explore-vie"><T><Button className="ad_explore_market_button mt-2"><img alt="AT" className="ad_25x25px" src="/gfx/austria-icon-0.svg"/><span className="pl-2">Austrian</span></Button></T></A></span>,
		"FOREX":    <span key="bank" className="p-2"><A href="/explore-bank"><T><Button className="ad_explore_market_button mt-2"><img alt="Bank" className="ad_25x25px" src="/gfx/currencies-0.svg"/><span className="pl-2">Currencies</span></Button></T></A></span>,
		"US_STOCK": <span key="us" className="p-2"><A href="/explore-us"><T><Button className="ad_explore_market_button mt-2"><img alt="USA" className="ad_25x25px" src="/gfx/usa-icon-0.svg"/><span className="pl-2">American</span></Button></T></A></span>,
		"COMMODITIES": <span key="comm" className="p-2"><A href="/explore-commodities"><T><Button className="ad_explore_market_button mt-2"><img alt="Commodities" className="ad_25x25px" src="/gfx/commodities-icon-0.svg"/><span className="pl-2">Commodities</span></Button></T></A></span>,
		"CRYPTOCURRENCIES": <span key="crypto" className="p-2"><A href="/explore-crypto"><T><Button className="ad_explore_market_button mt-2"><img alt="Crypto" className="ad_25x25px" src="/gfx/crypto-icon-0.svg"/><span className="pl-2">Crypto</span></Button></T></A></span>,
        "ETFS": <span key="etf" className="p-2"><A href="/explore-etfs"><T><Button className="ad_explore_market_button mt-2"><img alt="EFTs" className="ad_25x25px" src="/gfx/eft-icon-0.svg"/><span className="pl-2">ETFs</span></Button></T></A></span>,
        "INDEXES": <span key="index" className="p-2"><A href="/explore-indexes"><T><Button className="ad_explore_market_button mt-2"><img alt="Indexes" className="ad_25x25px" src="/gfx/indexes-icon-0.svg"/><span className="pl-2">Indexes</span></Button></T></A></span>,
        "FUNDS": <span key="funds-and-bonds" className="p-2"><A href="/explore-funds"><T><Button className="ad_explore_market_button mt-2"><img alt="Funds-and-bonds" className="ad_25x25px" src="/gfx/funds-and-bonds-icon-0.svg"/><span className="pl-2">Funds and Bonds</span></Button></T></A></span>
	};

	const market_set = array2set(props.markets || [])

	var buttons = [];
	for (const market_id of ordered_and_available_market_ids) {
		if (!market_set[market_id] || !market_buttons[market_id]) continue;
		buttons.push(market_buttons[market_id]);
	}
	return buttons;
}

function LargePortfolioChart(props) {
	return <RangedChart range_in="state" type="portfolio" inner={LargeChartInner} {...props}/>
}

function LargeGameChart(props) {
	return <RangedChart range_in="state" type="game" inner={LargeChartInner} {...props}/>
}

var PortfolioExplorerRow = (props) => {
	const asset = props.asset;
	const href = R.href("/ticker/:exchange/:ticker", {exchange: asset.Exchange, ticker: asset.Ticker});
	const mk_interval_td = (interval, td_classes) => {
		var inner;
		if (asset.Change && asset.Change[interval]) {
			const change = asset.Change[interval];
			inner = <ChangeArrow pct={change.RelativeChange*100} suffix="%"/>;
		} else {
			inner = <ChangeArrow svg_only pct={0} suffix="%"/>;
		}
		return <td className={td_classes}>{inner}</td>
	};

    let name = asset.Name;
    if (asset.Exchange === 'NYSE-ARCA' || asset.Exchange === 'NASDAQ') {
        name = setCommodityName(asset.Ticker, asset.Name);
    }

	return (
		<tr className={props.tr_classes}>
			<td className="ad_th_1px align-middle py-md-2 pl-2 pl-md-4">
				<A href={href}>
					<Logo className="logo ad_logo_list" size="24" exchange={asset.Exchange} ticker={asset.Ticker}/>
				</A>
			</td>
			<td className="pl-0 mr-0 py-md-2 align-middle table-cell-min">
				<span className="text-overflow-dynamic-container">
					<span className="text-overflow-dynamic-ellipsis">
						<A href={href}>{name}</A>
					</span>
				</span>
			</td>
			<td className="align-middle py-md-2">
				{I18N.floatval_unit(asset.StockRate, 2, asset.StockCurrency)}
			</td>
			{mk_interval_td("1d", "align-middle py-md-2")}
			{mk_interval_td("7d", "d-none d-md-table-cell align-middle py-md-2")}
			{mk_interval_td("1m", "d-none d-md-table-cell align-middle py-md-2")}
			{mk_interval_td("3m", "d-none d-md-table-cell align-middle py-md-2")}
			{mk_interval_td("1y", "d-none d-md-table-cell align-middle py-md-2")}
		</tr>
	)
}

function CalculateBetaValue(totalValue, stockValue, betaValue) {
    if (betaValue !== 0) {
        return ((stockValue / totalValue) * betaValue)
    }

    return 0;
}

function PortfolioRow(props) {
	const ass = props.asset;
	const game_currency = props.game_currency;
	const shortingEnabled = props.is_game && props.shorting_enabled === true;
	const showTypeColumn = shortingEnabled && (ass.Type === "long" || ass.Type === "short");
	const isShort = ass.Type === "short" || ass.HasShortPosition;

	const quantityVal = (typeof ass.DisplayQuantity === "number" && !Number.isNaN(ass.DisplayQuantity))
		? ass.DisplayQuantity
		: (typeof ass.Quantity === "number" ? ass.Quantity : 0);
	const valueVal = (typeof ass.DisplayValue === "number" && !Number.isNaN(ass.DisplayValue))
		? ass.DisplayValue
		: (typeof ass.Value === "number" ? ass.Value : 0);
	const baseDeltaMoney = valueVal - valueVal / (1 + (ass.ValueGrowth || 0));
	const total_delta_money = (typeof ass.totalDeltaMoney === "number") ? ass.totalDeltaMoney : baseDeltaMoney;
	const total_delta_pct = (typeof ass.totalDeltaPct === "number") ? ass.totalDeltaPct : (ass.ValueGrowth || 0) * 100;
	const priceNow = (typeof ass.priceNow === "number")
		? ass.priceNow
		: (quantityVal ? valueVal / quantityVal : ass.StockRate);
	const entryPrice = (typeof ass.entryPrice === "number")
		? ass.entryPrice
		: (quantityVal ? (valueVal - baseDeltaMoney) / quantityVal : ass.StockRate);

	var action_elements;
	if (props.enable_actions) {
		if (props.is_game) {
			action_elements = (
				<TradeButton
					exchange={ass.Exchange}
					ticker={ass.Ticker}
					portfolio_id={props.portfolio_id}
					refresh={props.refresh}
					portfolio={true}
				/>
			);
		} else {
			var remove = function() {
				API.post("/a/delete_stock_from_portfolio", {
					portfolio_id: props.portfolio_id,
					exchange: ass.Exchange,
					ticker: ass.Ticker
				}, function() {
					props.refresh();
				});
			};
			action_elements = (
				<Butt className="ad_btn_danger ad_btn_sm" onClick={remove}>
					<T>Remove</T>
				</Butt>
			);
		}
	}

	const quantity = I18N.floatval(quantityVal, ass.NDecimals);
	const total_change_percent = <ChangeArrow pct={total_delta_pct} suffix="%" />;
	const total_suffix = " (" + props.render_static(I18N.floatval(total_delta_pct, 2)) + "%)";
	const total_change_money = (
		<ChangeArrow currency_unit={game_currency} pct={total_delta_money} suffix={total_suffix} />
	);

	const todayPct = (typeof ass.todayChangePct === "number")
		? ass.todayChangePct
		: ((ass.Change && ass.Change["1d"]) ? ass.Change["1d"].RelativeChange * 100 : null);
	const today_change_percent = (todayPct !== null && todayPct !== undefined)
		? <ChangeArrow pct={todayPct} suffix="%" />
		: <span className="ad_growth_zero">&mdash;&nbsp;%</span>;

	const href = R.href("/ticker/:exchange/:ticker", { exchange: ass.Exchange, ticker: ass.Ticker });

	return (
		<tr>
			{showTypeColumn && (
				<th className="d-none d-md-table-cell align-middle ad_th_1px pl-2 pl-md-5" scope="row">
					{isShort ? "Short" : "Long"}
				</th>
			)}

			{/* Quantity */}
			{(quantityVal !== 0) && (
				<th className="d-none d-md-table-cell align-middle ad_th_1px pl-2 pl-md-5" scope="row">
					{quantity}
				</th>
			)}

			{/* Logo + Name */}
			<td className="ad_th_1px align-middle py-md-2 pl-2 pl-md-4">
				<A href={href}>
					<Logo className="logo ad_logo_list" size="24" exchange={ass.Exchange} ticker={ass.Ticker} />
				</A>
			</td>
			<td className="pl-0 mr-0 align-middle table-cell-min py-md-2">
				<span className="text-overflow-dynamic-container">
					<span className="text-overflow-dynamic-ellipsis">
						<A href={href}>{ass.Name}</A>
					</span>
				</span>
			</td>

			{/* Value */}
			{valueVal !== 0 && (
				<td className="d-none d-md-table-cell align-middle py-md-2">
					{I18N.floatval_unit(valueVal, 2, game_currency)}
				</td>
			)}

			{/* Beta */}
			{props.is_beta_value_active === true && props.show_beta === true && (
				<td className="d-none d-md-table-cell align-middle py-md-2">
					{ass.BetaValue ? I18N.floatval_unit(ass.BetaValue, 4) : "-"}
				</td>
			)}

			{/* Quote */}
			{valueVal !== 0 && quantityVal !== 0 && (
				<td className="d-none d-md-table-cell align-middle py-md-2">
					{I18N.floatval_unit(priceNow, 2, game_currency)}&nbsp;({I18N.floatval_unit(entryPrice, 2, game_currency)})
				</td>
			)}

			{/* Total Change */}
			<td className="d-none d-md-table-cell align-middle py-md-2">
				{valueVal ? total_change_money : total_change_percent}
			</td>

			{/* Today Change */}
			{props.show_today && (
				<td className="d-none d-md-table-cell align-middle py-md-2">
					{today_change_percent}
				</td>
			)}

			{/* Mobile Compact */}
			<td className="d-table-cell d-md-none align-middle py-md-2">
				{total_change_percent}
			</td>

			{/* Actions */}
			{valueVal !== 0 && props.show_actions && (
				<td className="text-center py-md-2">{action_elements}</td>
			)}
		</tr>
	);
}

const PortfolioImpl = (props) => {
	const portfolio = props.portfolio;

	const is_brief = portfolio.IsBrief;
	const is_full = !is_brief;
	const is_game = !!portfolio.Portfolio.Game;
    let is_beta_value_active = false
	const right_now = (new Date()).getTime();
	var game_run_time;

	var rows = [];
	var game_currency_asset = null;
	let game_currency_ticker = default_currency;
	var total_orig = 0;
	var total_now = 0;
    var show_beta;
	var best_chart_range = "3m";
    var show_portfolio_info = false

	if(is_game) {
        is_beta_value_active = portfolio.Portfolio.Game.BetaValue;

		game_run_time = right_now - portfolio.Portfolio.Game.StartTime * 1000;
		if(game_run_time < 14*60*60*24*1000) {
			best_chart_range = "7d";
		}

        show_portfolio_info = portfolio.Portfolio.Game.PortfolioInfo;
	}

    if (props.show_beta === undefined && is_beta_value_active) {
        show_beta = true;
    } else {
        show_beta = false;
    }

	const refresh_after_action = () => {
		props.ctl.reload();
	}

	const portfolio_is_mine = !!props.is_owner;
	const portfolio_is_explorers = portfolio.IsExplorePortfolio;

    if(!portfolio_is_mine) show_beta = false;

	const game_is_ended = portfolio.Portfolio.Game && portfolio.Portfolio.Game.State === "ended";
	const show_today = !game_is_ended;
	let show_trade = !game_is_ended;

    if (!game_is_ended && portfolio.Portfolio.Game && portfolio.Portfolio.Game.PortfolioInfo && props.is_owner === false) {
        show_trade = false;
    }

	const SM = (() => {
		var columns = {};
		for (const ck of ["1d","7d","1m","3m","1y"]) {
			columns[ck] = {
				key: ((ck) => x => (x.Change[ck] && x.Change[ck].RelativeChange) || 0)(ck),
			};
		}
		return SortMagic(columns);
	})();

	let total_value = 0;
	let total_beta = 0;
	let totalLongValue = 0;
	let shortingCapValue = 0;

	const game = portfolio.Portfolio && portfolio.Portfolio.Game;
	const shortingEnabled = is_game && game && game.ShortingEnabled === true;
	const useDetailedShortBreakdown = shortingEnabled && !is_brief;

	const computeShortCapValue = () => {
		if (!is_game || game.ShortingEnabled !== true) {
			return 0;
		}
		const capPct = game.ShortingAmount || 0;
		const initialBankroll = game.InitialAmount || 0;
		return (capPct / 100.0) * initialBankroll;
	};

	shortingCapValue = computeShortCapValue();

	const totals = computePortfolioTotals(portfolio, {
		shortingEnabled,
		includeShortBreakdown: useDetailedShortBreakdown,
	});
	
	const adjustedTotal = totals.total;
	totalLongValue = totals.longTotal;
	total_now = adjustedTotal;
	total_value = adjustedTotal;

    for (const asset of portfolio.Assets) {
        const beta_value = CalculateBetaValue(total_value, asset.Value, asset.BetaValue)
        total_beta += beta_value;
    }

    for (const asset of portfolio.SellAssets) {
        const beta_value = CalculateBetaValue(total_value, asset.Value, asset.BetaValue)
        total_beta += beta_value;
    }

	var tr_i = 0;


for (const asset of SM.sort(portfolio.Assets)) {

	const beta_value = CalculateBetaValue(total_value, asset.Value, asset.BetaValue);
	let tr_classes = "";
	if (tr_i > 0) tr_classes = "ad_game_table_border";

	if (asset.IsGameCurrency) {
		game_currency_asset = asset;
		game_currency_ticker = game_currency_asset.Ticker;
		if (!is_game) total_orig += game_currency_asset.Value;
		continue;
	} else {
		if (!is_game) total_orig += asset.Value / (1 + asset.ValueGrowth);
	}

	const displayAssets = buildDisplayAssets(asset, {
		shortingEnabled,
		includeShortBreakdown: useDetailedShortBreakdown,
	});

	for (const da of displayAssets) {
		if (portfolio_is_explorers && !portfolio_is_mine) {
			rows.push(
				<PortfolioExplorerRow
					key={`${da.Exchange}:${da.Ticker}:${da.Type}`}
					asset={da}
					tr_classes={tr_classes}
					total_value={total_value}
					game_currency={game_currency_ticker}
					show_portfolio_info={show_portfolio_info}
				/>
			);
		} else {
			rows.push(
				<PortfolioRow
					render_static={props.render_static}
					key={`${da.Exchange}:${da.Ticker}:${da.Type}`}
					portfolio_id={portfolio.Portfolio.Id}
					asset={da}
					is_game={is_game}
					refresh={refresh_after_action}
					enable_actions={portfolio_is_mine}
					show_today={show_today}
					show_actions={!is_game || show_trade}
					tr_classes={tr_classes}
					game_currency={game_currency_ticker}
					is_beta_value_active={is_beta_value_active}
					total_value={total_value}
					show_beta={show_beta}
					calculated_beta={beta_value}
					shorting_enabled={shortingEnabled}
				/>
			);
		}
		tr_i++;
	}
}

	if (is_game) {
		total_orig = portfolio.Portfolio.Game.InitialAmount;
	}
	if (is_brief) total_now = portfolio.Total;

	const total_change_value = total_now - total_orig;
	const total_change_percent_value = total_orig ? (total_now / total_orig - 1) * 100 : 0;
	const risk_adjusted_return_value = (total_change_percent_value !== 0 && total_beta !== 0)
		? (total_change_percent_value / total_beta)
		: null;

	var total_change = total_change_value;
	var total_change_percent = total_change_percent_value;
	var risk_adjusted_return_percent = (risk_adjusted_return_value !== null)
		? I18N.floatval(risk_adjusted_return_value, 2)
		: "-";
	var total_change_suffix = " (" + props.render_static(I18N.floatval(total_change_percent, 2)) + "%)";

	total_change_percent = <ChangeArrow pct={total_change_percent} suffix="%"/>
	total_change = <ChangeArrow currency_unit={game_currency_ticker} pct={total_change} suffix={total_change_suffix}/>
	
	let summaryShortExposure = null;
	let summaryShortUtilizationPct = null;

	if (shortingEnabled) {
		let shortExposureLocal = 0;

		for (const asset of portfolio.Assets) {
			const shortQty = Math.abs(asset.ShortQuantity || 0);
			const shortValueAbs = Math.abs(asset.ShortValue || 0);
			if (shortQty > 0 || shortValueAbs > 0) {
				if (asset.ShortDisplayValue !== undefined && asset.ShortDisplayValue !== null) {
					shortExposureLocal += Math.abs(asset.ShortDisplayValue);
				} else if (asset.ShortEntryValue !== undefined && asset.ShortEntryValue !== null) {
					shortExposureLocal += Math.abs(asset.ShortEntryValue);
				} else if (shortValueAbs > 0) {
					shortExposureLocal += shortValueAbs;
				}
			}
		}

		const shortLimit = shortingCapValue || 0;
		summaryShortExposure = shortExposureLocal || 0;
		summaryShortUtilizationPct = shortLimit > 0 ? (summaryShortExposure / shortLimit) * 100 : null;
	}

	const fallbackShortExposure = (typeof portfolio.ShortExposure === "number") ? portfolio.ShortExposure : null;

	// We use useMemo, so we can pass the summary data to parent components
	// so we can use them in the new PortfolioInfoGrid component
	// - cause we have access to the data in here!
	const summaryData = useMemo(() => {
		const bankrollValue = game_currency_asset ? Number(game_currency_asset.Value) : null;
		const bankrollTicker = game_currency_asset ? game_currency_asset.Ticker : game_currency_ticker;
		const investedValue = totals.longTotal || 0;
		const totalValueNow = total_now;
		const totalChangeAbsolute = total_change_value;
		const totalChangePercent = total_change_percent_value;
		const riskAdjustedPercent = risk_adjusted_return_value;
		const shortProfitValue = totals.shortPL || 0;

		// Settings
		const shortEnabled = is_game && portfolio.Portfolio.Game && portfolio.Portfolio.Game.ShortingEnabled === true;
		const diversificationEnabled = is_game && portfolio.Portfolio.Game && portfolio.Portfolio.Game.DiversificationEnabled === true;
		const betaEnabled = is_game && portfolio.Portfolio.Game && portfolio.Portfolio.Game.BetaValue === true;

		return {
			totals: {
				bankrollValue,
				bankrollTicker,
				investedValue,
				betaScore: total_beta,
				shortProfit: shortProfitValue,
				shortUtilizationPct: summaryShortUtilizationPct,
				totalValue: totalValueNow,
				totalChangeAbsolute,
				totalChangePercent,
				riskAdjustedReturnPercent: riskAdjustedPercent,
			},
			settings: {
				shortingEnabled: shortEnabled,
				diversificationEnabled: diversificationEnabled,
				betaEnabled: betaEnabled,
			}
		};
	}, [
		game_currency_asset,
		game_currency_ticker,
		totals.longTotal,
		summaryShortExposure,
		summaryShortUtilizationPct,
		total_now,
		total_change_value,
		total_change_percent_value,
		risk_adjusted_return_value,
		total_beta,
		fallbackShortExposure,
	]);

	useEffect(() => {
		if (props.onSummaryChange && summaryData) {
			props.onSummaryChange(summaryData);
		}
	}, [props.onSummaryChange, summaryData]);

	var title;
	if (props.show_title) {
		var owner;
		if (!portfolio_is_mine) {
			owner = portfolio.Portfolio.OwnerScreenName;
		} else if (portfolio.Portfolio.Game) {
			owner = <T>your portfolio</T>;
		}
		if (owner) {
			title = <div className="ad_150pct pt-3"><b>{portfolio.Portfolio.Name} &mdash; {owner}</b></div>;
		} else {
			title = <div className="ad_150pct p-4"><b>{portfolio.Portfolio.Name}</b></div>;
		}
	}

	var chartElement;
	var chartPart;

	if (props.include_chart && !portfolio_is_explorers) {
		if(props.portfolio.Portfolio.Game) {
			chartPart = <LargeGameChart range={best_chart_range} game_id={props.portfolio.Portfolio.Game.Id} portfolio_id={props.portfolio.Portfolio.Id}/>;
		} else {
			chartPart = <LargePortfolioChart range={best_chart_range} id={portfolio.Portfolio.Id}/>;
		}

		chartElement = (
			<Row>
				<Col>
					{chartPart}
				</Col>
			</Row>
		);
	}

	var table_head, last_table_row;
	var top_border_class = "";

	if(!props.show_title) {
		top_border_class = " ad_no_border-top";
	}

	if (portfolio_is_explorers && !portfolio_is_mine) {
		table_head = (
			<tr>
				<th className={classes("ad_th_1px align-middle" + top_border_class)}/>
				<th className={classes("pl-0 mr-0" + top_border_class)}><T>Security</T></th>
				<th className={top_border_class}><T>Latest</T></th>
				<SM.Th colkey="1d" className={top_border_class}><T>Today</T></SM.Th>
				<SM.Th colkey="7d" className={classes("d-none d-md-table-cell" + top_border_class)}><T>7d</T></SM.Th>
				<SM.Th colkey="1m" className={classes("d-none d-md-table-cell" + top_border_class)}><T>1m</T></SM.Th>
				<SM.Th colkey="3m" className={classes("d-none d-md-table-cell" + top_border_class)}><T>3m</T></SM.Th>
				<SM.Th colkey="1y" className={classes("d-none d-md-table-cell" + top_border_class)}><T>1y</T></SM.Th>
			</tr>
		);
		last_table_row = <tr></tr>;
	} else {
		table_head = (
			<tr>
				{shortingEnabled && <th className="d-none d-md-table-cell ad_th_1px pl-2 pl-md-5 py-md-2"><T>Type</T></th>}
				{is_full && <th className="d-none d-md-table-cell ad_th_1px pl-2 pl-md-5 py-md-2"><T>Quantity</T></th>}
				<th className="ad_th_1px align-middle py-md-2"/>
				<th className="pl-0 mr-0 py-md-2"><T>Security</T></th>
				{is_full && <th className="d-none d-md-table-cell py-md-2"><T>Value</T></th>}
                {is_full && is_beta_value_active && <th className="d-none d-md-table-cell py-md-2"><T>Risk Score</T></th>}
				{is_full && <th className="d-none d-md-table-cell py-md-2"><T>Quote (Paid)</T></th>}
				<th className="d-none d-md-table-cell py-md-2"><T>Change</T></th>
				{show_today && <th className="d-none d-md-table-cell py-md-2"><T>Today</T></th>}
				<th className="d-table-cell d-md-none py-md-2"><T>Percent</T></th>
				{is_full && show_trade && <th className="text-center py-md-2">{is_game ? <T>Trade</T> : <T>Remove</T>}</th>}
			</tr>
		);
		last_table_row = (
			<tr>
				{is_full && <th className="d-none d-md-table-cell" scope="row"/>}
				{is_full && <td className="d-none d-md-table-cell"/>}
				<td className="text-right pl-2 pl-md-4"><strong>Total:</strong></td>
				<td>
					<span className="ad_double_bottom_total">
						{I18N.floatval_unit(total_now, 2, game_currency_ticker)}
					</span>
				</td>
				{is_brief && <td/>}
                {is_full && is_beta_value_active && <td/>}
				<td className="d-none d-md-table-cell"/>
				{is_full && <td className="ad_ws_nowrap d-none d-md-table-cell">{total_change}</td>}
				{is_full && <td className="d-table-cell d-md-none">{total_change_percent}</td>}
                {is_full && is_beta_value_active && <td/>}
				{is_full && show_today && <td/>}
				{is_full && show_trade && <td/>}
			</tr>
		);
	}

	var table_graph_element;
	var explore_buttons = "";
	if(props.portfolio.Portfolio.Game) {
		explore_buttons = (
			<Col className="text-center py-4">
				<div className="d-none d-md-block">
					<ExploreMarketsButtons markets={props.portfolio.Portfolio.Game.Markets}/>
				</div>
				<div className="d-block d-md-none">
					<ExploreMarketsButtons smartphone={true}/>
				</div>
			</Col>
		);
	}

	var no_equities_element;
	if (is_full) {
		no_equities_element = (
					<Col className="text-center" xs="12">
						<h2 className="ad_gray_fg pb-0"><T>You have no equities</T></h2>
						<div className="pt-0 ad_light_gray_fg"><T>Explore our markets and find some</T></div>
					</Col>
					);
	} else {
		no_equities_element = (
					<Col className="text-center" xs="12">
						<h2 className="ad_gray_fg pb-0"><T>There are no equities</T></h2>
						<div className="pt-0 pb-3 ad_light_gray_fg"><T>This portfolio is pure cash</T></div>
					</Col>
				);
	}

	var previously_traded_element;
	if (props.allow_previously_traded && is_game && portfolio.PreviouslyTraded.length > 0) {
		var stock_elements = portfolio.PreviouslyTraded.map((stock) => {
			const key = stock.Exchange + ":" + stock.Ticker
			const href = R.href("/ticker/:exchange/:ticker", {exchange: stock.Exchange, ticker: stock.Ticker});
			return (
				<BlessLink><Button key={key} href={href} className="text-left ad_prev_trade_button flex-grow-1 m-2">
					<div style={{"minHeight": "60px"}} className="d-flex flex-column justify-content-center">
						<LogoAndInfo exchange={stock.Exchange} ticker={stock.Ticker} name={stock.Name} hasData={true} />
					</div>
				</Button></BlessLink>
			);
		});

		previously_traded_element = (
			<div>
				<h4><T>Equities previously traded in game</T></h4>
				<div className="row justify-content-between p-3 d-flex">
					{stock_elements}
				</div>
			</div>
		);
	}

	if (tr_i === 0) {
		table_graph_element = (
			<G>
				<Row className="">
					<Col className="pt-4 text-center" xs="12">
						<img alt="no equities" src="/gfx/no_assets_icon_big-0.svg"/>
					</Col>
					{no_equities_element}
					{is_full && explore_buttons}
				</Row>
				{previously_traded_element}
			</G>
		);
	} else {
		table_graph_element = (
			<G>
				<Row className="justify-content-left">
					<Col className="p-0">
						<Table className="table-borderless" size="sm">
							<thead className="ad_portfolio_thead font-90">
								{table_head}
							</thead>
							<tbody className="font-90">
								{rows}
								{last_table_row}
							</tbody>
						</Table>
					</Col>
				</Row>
				
				{!portfolio_is_mine && previously_traded_element}
				{portfolio_is_mine && explore_buttons}
			</G>
		);

	}
	return (
		<Container className="m-0 p-0">
			<div className="d-flex justify-content-between">
				{title}
				{props.me && !portfolio_is_mine && !portfolio_is_explorers && (
					<div className="py-3">
						<Follow user_id={portfolio.Portfolio.OwnerUserId}/>
					</div>
				)}
			</div>

			{table_graph_element}
			{chartElement}
		</Container>
	);
}



const PublicPortfolio = Apify("/z/portfolio_assets")
	.with_query_from_props(props => ({portfolio_id: props.portfolio_id, lang: R.get_current_language()}))
	.with_4xx_prop("error")
	.with_response_prop("portfolio")
	.wrap((props) => {
		const { onSummaryChange, ...rest } = props;
		if (props.error) return null;
		return (
			<React.Fragment>
				<TraksConsumer>
					<PortfolioImpl {...rest} onSummaryChange={onSummaryChange}/>
				</TraksConsumer>
			</React.Fragment>
		);
	});

var PrivatePortfolio = Apify("/a/my_portfolio_assets")
	.with_query_from_props(props => ({portfolio_id: props.portfolio_id, lang: R.get_current_language()}))
	.with_response_prop("portfolio")
	.with_ctl_prop()
	.wrap((props) => {
		const { onSummaryChange, ...rest } = props;
		return <TraksConsumer><PortfolioImpl {...rest} is_owner={true} onSummaryChange={onSummaryChange}/></TraksConsumer>;
	});

const ResolveFirst = Apify("/a/is_portfolio_owner")
	.with_query_from_props(props => ({portfolio_id: props.portfolio_id}))
	.with_response_prop("is_owner")
	.wrap((props) => {
		if (props.is_owner) {
			return <PrivatePortfolio {...props}/>
		} else {
			return <PublicPortfolio {...props}/>
		}
	});

const PortfolioWithResolve = connect(
	(state) => ({me: state.me})
)((props) => {
	if (props.me) {
		return <ResolveFirst {...props}/>
	} else {
		return <PublicPortfolio {...props}/>
	}
});

export {
	PortfolioWithResolve,
	PublicPortfolio,
	PrivatePortfolio,
}



// WEBPACK FOOTER //
// ./src/c/Portfolio.js